module.exports = __webpack_public_path__ + "media/bgm.552cbcf0.mp3";